import { render, staticRenderFns } from "./myAfterSales.vue?vue&type=template&id=12289408&scoped=true&"
import script from "./myAfterSales.vue?vue&type=script&lang=js&"
export * from "./myAfterSales.vue?vue&type=script&lang=js&"
import style0 from "./myAfterSales.vue?vue&type=style&index=0&id=12289408&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12289408",
  null
  
)

export default component.exports